/* @flow */
import * as React from 'react';

import BoxBody from 'components/BoxBody';
import BoxFooter from 'components/BoxFooter';
import Button from 'components/ButtonDeprecated';
import Copy from 'components/Copy';
import DialogContent from 'components/DialogContent';
import Link from 'components/Link';
import Row from 'components/Row';
import UnsubscribeActions from 'actions/UnsubscribeActions';
import SETTINGS_ROUTES from 'settings/constants/SettingsRouteConstants';

class MarketingEmailUnsubscribeView extends React.Component<$FlowFixMeProps, $FlowFixMeState> {
  state = {
    disabled: true,
    error: false,
    unsubscribe: null,
    unsubscribeError: null,
    concluded: false,
  };

  componentDidMount() {
    const onSuccess = unsubscribe => {
      this.setState({
        disabled: false,
        unsubscribe,
      });
    };
    const onError = response => {
      this.setState({
        error: response.error,
      });
    };
    UnsubscribeActions.confirm(this.props.params.token).then(onSuccess, onError);
  }

  handleUnsubscribeButtonClick = () => {
    this.setState({
      disabled: true,
    });

    if (!this.state.unsubscribe) {
      console.error('missing unsubscribe entity');
      return;
    }

    UnsubscribeActions.unsubscribe(this.state.unsubscribe).then(
      () => {
        this.setState({
          concluded: true,
        });
      },
      response => {
        this.setState({
          concluded: true,
          unsubscribeError: response.error,
        });
      }
    );
  };

  renderConclusion = () => {
    let title = 'You are now unsubscribed.';
    let glyph = 'check';
    let color = 'atlas';
    if (this.state.unsubscribeError) {
      title = this.state.unsubscribeError;
      glyph = 'caution';
      color = 'apple';
    }
    return <DialogContent size="small" title={title} glyph={glyph} glyphColor={color} />;
  };

  renderConfirmation = () => {
    let title;
    if (this.state.unsubscribe) {
      // Maybe in the future put another message for when a person is already unsubscribed
      title = 'Are you sure you want to unsubscribe from Remind marketing emails?';
    } else {
      title = this.state.error;
    }

    return (
      <DialogContent size="small" title={title} glyph="caution" glyphColor="apple">
        <BoxBody>
          {this.state.unsubscribe && (
            <Row>
              <Copy>
                <p>
                  We understand—your inbox can get busy. Click on the button below to stop receiving
                  marketing emails from Remind at {this.state.unsubscribe.getEmail()}. You’ll still
                  receive messages from any classes you belong to.
                </p>
                <p>
                  If you’d like to edit your contact information, change your notification
                  preferences, or download the Remind app,{' '}
                  <Link to={SETTINGS_ROUTES.NOTIFICATIONS}>visit your account</Link> instead.
                </p>
              </Copy>
            </Row>
          )}
          <Button
            onClick={this.handleUnsubscribeButtonClick}
            disabled={this.state.disabled}
            level="primary">
            Unsubscribe
          </Button>
        </BoxBody>
        <BoxFooter>
          Click <Link to={SETTINGS_ROUTES.NOTIFICATIONS}>here</Link> to edit message preferences
        </BoxFooter>
      </DialogContent>
    );
  };
  render() {
    if (this.state.concluded) {
      return this.renderConclusion();
    } else {
      return this.renderConfirmation();
    }
  }
}
export default MarketingEmailUnsubscribeView;
